import React from 'react';
import { Link } from 'react-router-dom';

/**
 * ProfileLink Component
 *
 * A standardized component for displaying profile links across the application.
 * Features:
 * - Consistent styling for all profile links
 * - Hover effects with underline
 * - Dark mode support
 * - Focus states for accessibility
 *
 * @param {Object} props
 * @param {string} props.to - The route path to navigate to
 * @param {string} props.children - The link text/content to display
 * @param {string} props.ariaLabel - Accessible label for screen readers
 * @param {string} props.className - Additional CSS classes to apply (optional)
 */
const ProfileLink = ({ to, children, ariaLabel, className = '', state }) => {
  // visited: — профиль, который уже открывали, выделен цветом, как посещённая
  // ссылка в поиске: в длинных таблицах видно, кого уже смотрели.
  // Браузер разрешает на :visited менять только цвет — этого и хватает
  const baseClasses = "text-sm font-medium text-light-text-primary dark:text-dark-text-primary visited:text-purple-700 dark:visited:text-purple-400 hover:text-primary-600 dark:hover:text-primary-400 underline-offset-2 hover:underline focus:outline-none focus:ring-2 focus:ring-primary-500 rounded";

  return (
    <Link
      to={to}
      state={state}
      aria-label={ariaLabel}
      className={`${baseClasses}${className ? ' ' + className : ''}`}
    >
      {children}
    </Link>
  );
};

export default ProfileLink;
